import { Baby, CheckCircle2, Trophy, Users, PawPrint } from "lucide-react";
import type { NavigationItem } from "@/shared/types/navigation";

/**
 * Sidebar navigation for the habits app. Order = the primary flow (habits →
 * Вместе → challenges → pets). Points + Rewards are NOT nav items — the hub
 * surfaces both (per-person balances + a rewards summary), so separate pages felt
 * empty; those routes stay reachable from the hub. Labels are i18n keys under
 * `habits.nav.*`; hrefs are locale-relative (the next-intl <Link> prepends the
 * active `/<locale>/`). The 3D scene (`/pets`) renders fullscreen OUTSIDE this
 * chrome — the sidebar link just navigates there.
 */
export const habitsNavItems: NavigationItem[] = [
  {
    id: "habits",
    category: "habits",
    name: "habits.nav.habits.name",
    description: "habits.nav.habits.description",
    icon: CheckCircle2,
    href: "/habits",
  },
  {
    id: "pack",
    category: "habits",
    name: "habits.nav.pack.name",
    description: "habits.nav.pack.description",
    icon: Users,
    href: "/together",
  },
  {
    id: "challenges",
    category: "habits",
    name: "habits.nav.challenges.name",
    description: "habits.nav.challenges.description",
    icon: Trophy,
    href: "/challenges",
  },
  {
    id: "pets",
    category: "habits",
    name: "habits.nav.pets.name",
    description: "habits.nav.pets.description",
    icon: PawPrint,
    href: "/pets",
  },
  {
    // handing a child a temporary link is a parent's errand: it used to live only inside the
    // child-facing 3D scene, which is the wrong place to do it from
    id: "kid-links",
    category: "habits",
    name: "habits.nav.kidLinks.name",
    description: "habits.nav.kidLinks.description",
    icon: Baby,
    href: "/kid-links",
  },
  // Notifications are NOT a top-level nav item (it confused users): channel setup
  // lives inline in the reminder popover / create-habit dialog + the accounts
  // profile. The /notifications page still exists as a direct link if needed.
];
